<template>
    <div>
        <div class="px-3 px-sm-5 py-4">
            <div class="panel mb-0">
                <div class="panel-hdr d-block pt-4 p-3">
                    <div class="ml-auto mb-3 text-right">
                        <exportCSV class="link btn buttons-csv buttons-html5 btn-primary mr-2"
                            :data="exportData"
                            :fields="exportFields"
                            :header="exportHeaders"
                            type="csv"
                            :escapeCsv="false"
                            :name="exportFileName">
                            <span>CSV</span>
                        </exportCSV>
                        <!-- <button class="btn buttons-csv buttons-html5 btn-secondary ml-2" type="button" title="Generate PDF">
                            <span class="mr-3">PDF</span>
                            <i class="arrow-down fas fa-angle-down"></i> 
                        </button> --> 
                    </div>
                </div>
                <div class="panel-container">
                    <div class="panel-content">
                        <div v-if="isSpinnerShow" class="d-flex justify-content-center mt-3 mb-3">
                            <b-spinner label="Loading..."></b-spinner>
                        </div>
                        <div class="panel-tag mt-3" v-if="!isSpinnerShow && totalEntries == 0">{{$t('table.no_records')}}</div>
                        <div v-if="!isSpinnerShow && totalEntries != 0" class="dataTables_wrapper dt-bootstrap4">
                            <div class="row justify-content-end mt-2">
                                <div class="col-auto pt-2">
                                    <span>{{$t('table.pagination', {'startPage': startPage, 'endPage': endPage, 'totalEntries': totalEntries,})}}</span>
                                </div>
                                <div class="col-auto">
                                    <b-pagination class="ml-3" v-model="currentPage" :per-page="perPage" :total-rows="totalEntries" @input="handlePagination"></b-pagination>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-sm-12 overflow-auto">
                                    <b-table striped hover bordered :fields="fields" :items="userItems" responsive>
                                        <template #cell(index)="data">
                                            {{ data.index + startPage }}
                                        </template>
                                        <template #cell(username)="data">
                                            <a v-if="userPermission && data.item.blocked" class="link text-primary fw-500" :title="$t('button_link.view') + $t('user.header_block_permission')" @click="viewBlockPermission(data.item.userID, data.item.username, true)">{{data.item.username}}</a>
                                            <span v-else>{{data.item.username}}</span>
                                        </template>
                                        <template #cell(loginDate)="data">
                                            {{data.item.loginDate == 0 ? '-' : convertTimestampToDateTime(data.item.loginDate)}}
                                        </template>
                                        <template #cell(blockDate)="data">
                                           <b-form-checkbox :disabled="data.item.username == loginUsername" button-variant="danger" v-model="data.item.blocked" @change="blockEmit(data.item)" switch>{{!data.item.blocked ? 'Blocked':'Active'}}</b-form-checkbox>
                                        </template>
                                        <template #cell(outlet)="data">
                                            <a class="link d-block text-primary" :title="$t('user.header_view_edit')" @click="viewUserOutlet(data.item.userID, data.item.username, false)">
                                                <div class='icon-stack fs-xl'>
                                                    <i class="fal fa-store icon-stack-3x opacity-100 color-primary-500"></i>
                                                    <i class="fal fa-cog icon-stack-2x opacity-100 color-primary-300 ml-3" style="top: .5em;"></i>
                                                </div>
                                            </a>
                                        </template>
                                        <template #cell(action)="data">
                                            <a v-if="data.item.username != loginUsername" class="link d-block text-primary" :title="$t('button_link.delete') + $t('subMenu.my_salon_user')" @click="deleteUser(data.item.userID, data.item.username)">
                                                <i class="fal fa-trash"></i>
                                            </a>
                                            <a v-else class="d-block text-secondary" :title="$t('message.error.access_denied_user')" disabled>
                                                <i class="fas fa-trash"></i>
                                            </a>
                                        </template>
                                    </b-table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div :class="{'show': viewPermissionToggle }" class="modal fade">
            <div class="modal-dialog modal-lg">
                <div class="modal-content modal-content-lg">
                    <div class="modal-header border-bottom">
                        <h5 class="modal-title h4">{{isViewPermission ? $t('user.header_block_permission') : $t('user.header_view_edit')}}</h5>
                        <button type="button" class="close" @click="viewPermissionToggle = false">
                            <span aria-hidden="true"><i class="fal fa-times"></i></span>
                        </button>
                    </div>
                    <div class="modal-body modal-body-lg">
                        <input type="hidden" v-model="userID"/>
                        <div class="accordion accordion-clean" role="tablist">
                            <b-card v-show="username != loginUsername && updateUserOutletPermission" no-body>
                                <b-card-header header-tag="header" role="tab">
                                    <a class="card-title" block v-b-toggle.accAddPermission>{{isViewPermission ?  $t('button_link.add') + $t('user.restriction') : $t('button_link.edit') + $t('user.user_outlet')}}
                                        <span class="ml-auto">
                                            <span class="collapsed-reveal">
                                                <i class="fal fa-chevron-up fs-xl"></i>
                                            </span>
                                            <span class="collapsed-hidden">
                                                <i class="fal fa-chevron-down fs-xl"></i>
                                            </span>
                                        </span>
                                    </a>
                                </b-card-header>
                                <b-collapse id="accAddPermission" accordion="accordion" role="tabpanel">
                                    <b-card-body class="card-body">
                                        <userPermissionForm :key="keyUserPermissionForm" v-show="isViewPermission" ref="userPermissionForm" :username="username" :userID="userID" :permissionType="permissionType" @updateList="updateList" @resetPermissionList="resetPermissionList"></userPermissionForm>
                                        <userOutletForm v-show="!isViewPermission" ref="userOutletForm" :username="username" :userID="userID" :userOutlet="userOutlet" @resetOutletList="resetOutletList" ></userOutletForm>
                                    </b-card-body>
                                </b-collapse>
                            </b-card>
                            <b-card no-body >
                                <b-card-header header-tag="header" role="tab">
                                    <a id="accKey" class="card-title" block v-b-toggle.accListPermission>{{isViewPermission ? $t('user.header_restriction') : $t('user.header_outlet')}}
                                        <span class="ml-auto">
                                            <span class="collapsed-reveal">
                                                <i class="fal fa-chevron-up fs-xl"></i>
                                            </span>
                                            <span class="collapsed-hidden">
                                                <i class="fal fa-chevron-down fs-xl"></i>
                                            </span>
                                        </span>
                                    </a>
                                </b-card-header>
                                <b-collapse id="accListPermission" accordion="accordion" role="tabpanel">
                                    <b-card-body class="card-body">
                                        <div class="modal-container">
                                            <userPermissionList v-show="isViewPermission" ref="userPermissionList" @setPermissionType="setPermissionType"></userPermissionList>
                                            <userOutletList v-show="!isViewPermission" ref="userOutletList" @setUserOutlet="setUserOutlet"></userOutletList>
                                        </div>
                                    </b-card-body>
                                </b-collapse>
                            </b-card>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <deleteModal ref="deleteModal" @performConfirmAction="performDeleteAction"></deleteModal>
    </div>
</template>
<script>
import moment from 'moment'
import DeleteModal from './../../Delete_Modal'
import UserPermissionForm from './User_Permission_Form'
import UserPermissionList from './User_Permission_List'
import UserOutletList from './User_Outlet_List'
import UserOutletForm from './User_Outlet_Form'
import {handleSessionExpired, setReturnData} from './../../../../assets/js/dashboard/dashboard'
export default {
    name: 'userList',
    components:{
        UserPermissionList, UserPermissionForm,
        UserOutletList, UserOutletForm,
        DeleteModal
    },
    data(){
        return {
            isSpinnerShow: false,
            userItems: [], permissionType: [], userOutlet: [], userExportData: [],
            isViewPermission: true, deleteUserPermission: true, userPermission: true,
            userOutletPermission: true, updateUserOutletPermission: true, 
            deleteToggleModal: false, viewPermissionToggle: false, userID: 0, username: "", loginUsername: "",
            page: 0, totalEntries: 0, totalPage: 0, startPage: 1, endPage: 0, perPage: 100, currentPage: 1,
            exportHeaders: [], exportData: [], exportFileName: "",
            keyUserPermissionForm: 0, cachedLength: null
        }
    },
    computed:{
        fields(){
            var ret = []
            ret.push({ key: "index", label: "#", thClass: 'thead-themed align-middle', tdClass: 'align-middle'})
            ret.push({ key: "username", label: this.$i18n.t('table.header.username'), thClass: 'thead-themed align-middle', tdClass: 'align-middle',sortable: true})
            ret.push({ key: "mobile", label: this.$i18n.t('table.header.contact'), thClass: 'thead-themed align-middle', tdClass: 'align-middle'})
            ret.push({ key: "loginDate", label: this.$i18n.t('table.header.loginDate'), thClass: 'thead-themed align-middle', tdClass: 'align-middle', sortable: true})
            ret.push({ key: "blockDate", label: 'Status', thClass: 'thead-themed align-middle', tdClass: 'align-middle', sortable: true})
            if(this.deleteUserPermission){
                ret.push({ key: "action", label: "", thClass: 'thead-themed text-center', tdClass: 'align-middle text-center'})
            }
            return ret
        },
        exportFields(){
            var ret = {}
            ret["#"] = "index"
            ret[(this.$i18n.t('table.header.shopName')).toUpperCase()] = "shopName"
            ret[(this.$i18n.t('table.header.username')).toUpperCase()] = "username"
            ret[(this.$i18n.t('table.header.contact')).toUpperCase()] = "mobile"
            ret[(this.$i18n.t('table.header.loginDate')).toUpperCase()] = "loginDate"
            ret[(this.$i18n.t('table.header.blockDate')).toUpperCase()] = "blockDate"
            return ret
        },
    },
    watch:{
        "$i18n.locale"(val){
            this.keyUserPermissionForm += 1
            this.setExportData(this.userExportData)
        }
    },
    methods:{
        async blockEmit(data){
            let result = []; 
            let url = ""
            if(!data.blocked)
            url = `${this.$api.USERS}/${data.userID}/unblock`;
            else
            url = `${this.$api.USERS}/${data.userID}/block`;
          await this.$axios({
        method: "post",
        url: url,
        baseURL:this.$api.API_ENDPOINT_BEBUSINESS,
        headers: { token: this.$session.get("token") },
      })
        .then(function (response) {
          result = response;
        })
        .catch((err) => {
          var errData = err.response.data;
          if (errData.error == this.$api.INVALID_TOKEN) {
            handleSessionExpired();
          }
        });
        if (result.status == 200) {
        !data.blocked ? this.toastrExe("Blocked", `User ${data.userID} has been blocked`, "success"):this.toastrExe("Unblocked", `User ${data.userID} has been unblocked`, "success");
      } else {
        data.blocked = !data.blocked;
        this.toastrExe("Action", "Error.", "danger");
      }
    },
        toastrExe(title, body, variant) {
      this.$bvToast.toast(body, {
        title: title,
        variant: variant,
        solid: true,
      });
    },
        getTableHeaderStyle(id){
            var style = ""
            switch(id){
                case"action":
                    style = !this.deleteUserPermission ? 'display: none' : ''
                    break
                case"outlet":
                    style = !this.userOutletPermission ? 'display: none' : ''
                    break
            }
            return style
        },
        closeModal(isError){
            if(!isError){
                this.deleteToggleModal = false
                this.getUserList()
                this.$refs.deleteModal.toggleModal = false
            }
            this.$parent.$parent.isModalShow = false
        },
        convertTimestampToDateTime(ts){
            return moment(ts*1000).format(this.$msg.CST.DATE_TIME_24)
        },
        setPermissionType(data){
            this.permissionType = data;
        },
        setUserOutlet(data){
            this.userOutlet = data
        },
        updateList(){
            this.$refs.userPermissionList.getBlockPermission(this.userID,this.username);
        },
        resetOutletList(){
            document.getElementById('accKey').click()
            this.$refs.userOutletList.getUserOutlet(this.userID, this.username)
        },
        resetPermissionList(){
            document.getElementById('accKey').click()
            this.$refs.userPermissionList.getBlockPermission(this.userID, this.username)
        },
        viewUserOutlet(id, title, isViewPermission){
            this.isViewPermission = isViewPermission
            this.userID = id
            this.username = title
            this.viewPermissionToggle = true
            this.$refs.userOutletList.getUserOutlet(id, title)
        },
        async viewBlockPermission(id, title, isViewPermission){
            this.isViewPermission = isViewPermission
            this.userID = id
            this.username = title    
            await this.$refs.userPermissionList.getBlockPermission(id, title)
            await this.$refs.userPermissionForm.setPermissionList();
            
            if(this.permissionType.length == 0 && this.permissionType.length != this.cachedLength)
            {
                this.$root.$emit('bv::toggle::collapse', 'accAddPermission')
            }
            else if(this.permissionType.length != 0 && this.permissionType.length != this.cachedLength){
                this.$root.$emit('bv::toggle::collapse', 'accListPermission');
            }
            this.cachedLength = this.permissionType.length
            this.viewPermissionToggle = true
        },
        performDeleteAction(){
            let $vm = this
            const url = "/users/" + this.userID  + $vm.$api.DELETE
                
            $vm.$axios({
                method: 'post', 
                url: url,
                baseURL: $vm.$api.API_ENDPOINT_BEBUSINESS, 
                headers: {token: $vm.$session.get('token')}
            })
            .then((response) => {
                if(response.status == 200){
                    var message = $vm.$i18n.t('message.success.delete', {'item': $vm.username})
                    $vm.$parent.$parent.setModal($vm, false, true, message)
                }
            })
            .catch((err) => {
                var errData = err.response.data;
                if(errData.error == $vm.$api.INVALID_TOKEN){
                    handleSessionExpired();   
                }
            })
        },
        deleteUser(id, username){
            this.userID = id
            this.username = username
            var title = this.$i18n.t('button_link.delete') + this.$i18n.t('subMenu.my_salon_user')
            var message = this.$i18n.t('message.confirmation.question', {'action': this.$i18n.t('message.confirmation.action.delete'),'item': username})
            this.$refs.deleteModal.showModal(title, message)
        },
        setExportData(data){
            let header = this.$msg.REPORT.HEADER + this.$i18n.t(`subMenu.my_salon_user`)
            this.exportHeaders = [header, this.$i18n.t('table.report_generate') + moment().format(this.$msg.CST.DATE_TIME_24),  " "];
            this.exportFileName =  header.split(" ").join("_") +  this.$msg.REPORT.CSV

            for(var i=0; i<data.length; i++){
                this.exportData.push({
                    index: i+1,
                    shopName: data[i].shopName,
                    username: data[i].username,
                    mobile: data[i].mobile,
                    loginDate: data[i].loginDate == 0 ? '-' : this.convertTimestampToDateTime(data[i].loginDate),
                    blockDate: data[i].blockDate == 0 ? '-' : this.convertTimestampToDateTime(data[i].blockDate),
                })
            }
        },
        getUserList(){
            let $vm = this
            $vm.totalEntries = 0;
            $vm.isSpinnerShow = true;

            $vm.$axios({
                method: 'get', 
                url: '/users',
                baseURL: $vm.$api.API_ENDPOINT_BEBUSINESS, 
                headers: {token: $vm.$session.get('token')}
            })
            .then(function(response) {
                var retData = setReturnData(response.data.users, response.data.users.length, $vm.page)
                let res = retData.result.forEach(element=>{
                    if(element.blockDate!= 0){
                        element.blocked = false;
                    }
                    else{
                        element.blocked = true;
                    }
                });
                $vm.userItems = retData.result;
                $vm.totalEntries = response.data.users.length;
                $vm.totalPage = retData.totalPage;

                $vm.startPage = retData.startPage;
                $vm.endPage = retData.endPage;
                $vm.isSpinnerShow = false;
                $vm.userExportData = retData.result
                $vm.setExportData(retData.result)
            })
            .catch((err) => {
                var errData = err.response.data;
                if(errData.error == $vm.$api.INVALID_TOKEN){
                    handleSessionExpired();   
                }
            })
        },
        handlePagination(pg){
            if(pg != null){
                this.page = pg - 1
                this.getUserList()
            }
        },
    },
    mounted(){
        let $vm = this;
        $vm.loginUsername = $vm.$store.state.userName
        $vm.getUserList()

        var blockList = $vm.$store.state.blockList
        for(var i=0; i<blockList.length; i++){
            switch(blockList[i]){
                case"biz.user.delete":
                    $vm.deleteUserPermission = false;
                    break;
                case"biz.user.outlet.*":
                    $vm.userOutletPermission = false;
                    break;
                case"biz.user.outlet.edit":
                    $vm.updateUserOutletPermission = false;
                    break;
                case"biz.user.permission.*":
                    $vm.userPermission = false;
                    break;
            }
        }
    },
}
</script>
<style lang="scss" scoped>
.link{
    cursor: pointer;
}
.show{
    display: block;
}
.modal-body-lg, .modal-container{
    max-height: 65vh;
    min-height: 75vh;
    overflow-x: hidden;
    overflow-y: auto;
}
// ::v-deep .custom-control-input~.custom-control-label::before{
//   border-color: #fd3995;
//     background-color:#fd3995;
// }

// ::v-deep .custom-control-input:checked~.custom-control-label::before{
//   border-color: rgb(6, 228, 6) !important;
//   background-color: rgb(6, 228, 6) !important;
// }
</style>